export const APP_NAME = 'Workforce Management System'
export const PERSIST_STORE_NAME = 'wms_admin'
export const REDIRECT_URL_KEY = 'redirectUrl'
